module.exports = "https://web-assets.ifttt.com/packs/media/partners/test-neutral-8e7a6233.svg";